import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { formatDate } from "../utils/formatTime";

const WithdrawsHistory = ({ payments }) => {
  return (
    <div>
      <Table responsive>
        <thead>
          <tr>
            <th>Data</th>
            <th>Valor</th>
            <th>Situação</th>
          </tr>
        </thead>
        <tbody>
          {payments.map(item => {
            return (
              <tr key={`payment-${item._id}`}>
                <th scope="row">{formatDate(item.createdAt)}</th>
                <td>R$ {item.value}</td>
                <td>{item.granted ? "Pago" : "Em espera"}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default WithdrawsHistory;
